import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF, Bounds } from '@react-three/drei';

const Model = ({ url }) => {
    const groupRef = useRef();
    const { scene } = useGLTF(url);
  
    useFrame(() => {
      if (groupRef.current) {
        groupRef.current.rotation.y += 0.01;
      }
    });
  
    return (
      <group ref={groupRef} position={[0, 0, 0]}>
        <primitive 
          object={scene} 
          position={[0, -1, 0]}  
          scale={[0.6, 0.6, 0.6]} 
        />
      </group>
    );
};
  
const Producto3D = ({ modelPath }) => {
  return (
    <Canvas camera={{ position: [0, 0, 5], fov: 30 }}>
          <ambientLight intensity={0.3} />
          <directionalLight position={[3, 3, 3]} />
          <Model url={modelPath} />
         {/* <OrbitControls enableZoom={false} /> */}
        </Canvas>
  );
};

export default Producto3D;
